import { Store, Module, ActionContext } from "vuex";
import ListModule from "../list-module";
import ListState from "../list-state";
import Supplier from "../../entities/booking/supplier";
import Ajax from "../../../lib/ajax";
import PageResult from "@/store/entities/page-result";

interface SupplierState extends ListState<Supplier> {
  editSupplier: Supplier;
  permissions: Array<string>;
  treePermissions: Array<TreePermission>;
}

interface TreePermission {
  title: string;
  checked: boolean;
  expand: boolean;
  children: Array<TreePermission>;
}
class SupplierModule extends ListModule<SupplierState, any, Supplier> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Supplier>(),
    loading: false,
    editSupplier: new Supplier(),
    permissions: new Array<string>(),
    treePermissions: new Array<TreePermission>(),
  };
  actions = {
    async getAll(context: ActionContext<SupplierState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/Supplier/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<Supplier>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async create(context: ActionContext<SupplierState, any>, payload: any) {
       await Ajax.post("/api/services/app/Supplier/Create", payload.data);
    },
    async update(context: ActionContext<SupplierState, any>, payload: any) {
      await Ajax.put("/api/services/app/Supplier/Update", payload.data);
    },
    async GetAllSupplierListLabelAndValue(
      context: ActionContext<SupplierState, any>,
      payload: any
    ) {
      return Ajax.get(
          "/api/services/app/Supplier/GetSupplierLableAndValue"
      );
    },
    async delete(context: ActionContext<SupplierState, any>, payload: any) {
      await Ajax.delete(
        "/api/services/app/Supplier/Delete?Id=" + payload.data.id
      );
    },
    async get(context: ActionContext<SupplierState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/Supplier/Get?Id=" + payload.id
      );
      return reponse.data.result as Supplier;
    },
  };
  mutations = {
    setCurrentPage(state: SupplierState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: SupplierState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: SupplierState, supplier: Supplier) {
      state.editSupplier = supplier;
    },
  };
}
const supplierModule = new SupplierModule();
export default supplierModule;
